export default "__VITE_ASSET__DxLp45F3__"